<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<style>
  @import './assets/css/weui.min.css';
</style>
<style lang="scss">
    @import './assets/sass/style.scss';
</style>
<script>
  export default{
    watch: {
      '$route' (to, from) {
        let mask = document.getElementsByClassName("weui-mask")[0];
        let picker = document.getElementsByClassName("weui-picker")[0];
        if (mask && picker) {
          var btn = document
            .getElementsByClassName("weui-picker")[0]
            .getElementsByClassName("weui-picker__action")[0];
          var e = document.createEvent("MouseEvents");
          e.initEvent("click", true, true);
          btn.dispatchEvent(e);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue